export const AllowedCompaniesForAvailability = [
  37, 106, 393, 418, 458, 434, 557, 629, 639, 645, 646, 666, 668, 670, 672, 132, 131, 270, 524, 405, 671, 675, 678, 680,
  681, 677, 682, 687, 690, 245, 702, 728, 720, 226, 719, 747, 788, 800, 804, 813, 734,
].concat([4]); // acceptance
export const AllowedCompaniesForWizard = [424, 645, 678, 680, 681, 677, 245, 719, 800, 804, 813, 734];
